<template>
    <div class="div">
        <el-form :inline="true" :model="params" class="demo-form-inline" size="mini" label-width="100px">
            <el-form-item label="字典列表">
                <el-input v-model="params.value" clearable placeholder="请输入字典列表"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button plain  @click="getData">查询</el-button>
                <el-button plain type="primary" @click="addDic">增加</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="dicList" style="width: 100%" height="calc(100vh - 134px)" size="mini">
            <el-table-column type="index" label="序号" max-width="200"></el-table-column>
            <el-table-column prop="value" label="字典值" width="auto" > </el-table-column>
            <el-table-column prop="type" label="字典类型" width="auto" :filters="filters" :filter-method="filterHandler" > </el-table-column>
            <el-table-column prop="createMan" label="创建人" width="auto" > </el-table-column>
            <el-table-column prop="status" label="状态" width="auto" > 
                <template slot-scope="scope">
                    <el-switch @change="changeStatus(scope.row)" v-model="scope.row.status"
                        active-color="#13ce66" inactive-color="#ff4949">
                    </el-switch>
                </template>
            </el-table-column>
        </el-table>
        <!-- 新增字典值 -->
        <el-dialog v-dialogDrag title="新增字典信息" :visible.sync="addDicShow"  width="40%" :before-close="cancel">
            <el-form :rules="rules" ref="addDicForm"   label-width="80px" :model="addDicData">
                <el-form-item label="字典类型" prop="type">
                    <el-select filterable  v-model="addDicData.type" placeholder="请选择字典类型" style="width:100%">
                        <el-option
                        v-for="item in dicTypeList"
                        :key="item.typeName"
                        :label="item.typeName"
                        :value="item.typeName">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="字典值" prop="value">
                    <el-input v-model="addDicData.value" clearable placeholder="请输入字典值"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="sure('addDicForm')">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
export default {
    data() {
        return {
            filters:[ ],
            params:{
                value:""
            },
            dicTypeList:[],
            dicList:[],
            addDicShow:false,
            addDicData:{
                value:"",
                type:"",
            },
            rules: {
                type: [
                    { required: true, message: '请选择字典类型', trigger: 'blur' }
                ],
                value: [
                    { required: true, message: '请输入字典值', trigger: 'blur' }
                ],
            },
        }
    },
    mounted() {
        // 获取字典类型
        this.getDicTypeList()
        this.getData()
    },
    methods: {
        // 获取字典类型列表
        getDicTypeList(){
            this.$api.getDicTypeList().then(res =>{
                this.dicTypeList = res
                this.filters = res.map(item => {
                    return {
                        text: item.typeName,
                        value: item.typeName,
                    }
                })
            })
        },
        // 获取字典数据列表
        getData(){
            this.$api.getDicList( this.params ).then(res =>{
                this.dicList = res.map(item =>{
                    item.status = item.status === 1 ? true : false
                    return item
                })
            })
        },
        filterHandler(value, row, column) {
            const property = column['property'];
            return row[property] === value;
        },
        addDic(){
            this.addDicShow = true
        },
        // 取消
        cancel(){
            this.$refs.addDicForm.resetFields();
            this.addDicShow = false
        },
        // 确认添加
        sure(formName){
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    // 添加
                    this.$api.addDic( this.addDicData ).then(res =>{
                        this.$message({
                        message: '新增成功',
                        type: 'success'
                    });
                    this.cancel()
                    this.getData()
                    })

                } else {
                    return false;
                }
            });
        },
        // 更改状态
        changeStatus(data){
            this.$api.updateStatus( data.id ).then(res =>{
                this.$message({
                    message: '字典更改状态完成',
                    type: 'success'
                });
                this.cancel()
                this.getData()
            })
        }
    }
}
</script>
<style lang="css" scoped>
.div{
    background-color: white;
    padding: 10px;
}
.el-table {
    margin-top: 0px;
}
.el-form-item {
    margin-bottom: 0px !important;
}
</style>